import * as React from "react";
import { Dispatch } from "react";

import { DataInput, LevelValue } from "../../dataInputTypes";

import { QualifiedFeature } from "fe-common/graphql";
import styled from "@mui/material/styles/styled";
import Button from "@mui/material/Button";
import { LevelShapeItem } from "./LevelShapeItem";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface LevelSelectComponentProps {
  qf: QualifiedFeature;
  response?: DataInput;
  onChange: Dispatch<DataInput>;
}

export const LevelSelectComponentView = styled("div")({
  display: "flex",
  alignItems: "flex-end",
});

export const LevelButton = styled(Button)({
  borderColor: "rgb(198, 198, 198)",
  fontSize: "14px",
  height: "fit-content",
  fontWeight: 400,
  width: "55px",
});

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const LevelSelectComponent = ({
  ...props
}: LevelSelectComponentProps) => {
  let level = props.response?.level || null;
  //let trackName = (num) => (num === 1 ? "High" : num === -1 ? "Low" : "Norm");

  const handleLevelChanged = (num: number | number[]) => {
    let level =
      num === 1
        ? LevelValue.HIGH
        : num === -1
        ? LevelValue.LOW
        : LevelValue.NORMAL;

    if (level !== props.response?.level) {
      props.onChange({ level });
    } else {
      props.onChange(null);
    }
  };

  return (
    <LevelSelectComponentView>
      <LevelShapeItem
        selected={level === LevelValue.LOW}
        showTitle={level === LevelValue.LOW}
        level={LevelValue.LOW}
        onClick={() => {
          handleLevelChanged(-1);
        }}
      />
      <LevelShapeItem
        selected={level === LevelValue.NORMAL}
        showTitle={true}
        level={LevelValue.NORMAL}
        onClick={() => {
          handleLevelChanged(0);
        }}
      />
      <LevelShapeItem
        selected={level === LevelValue.HIGH}
        showTitle={level === LevelValue.HIGH}
        level={LevelValue.HIGH}
        onClick={() => {
          handleLevelChanged(1);
        }}
      />
    </LevelSelectComponentView>
  );
};
